<template>
    <div class="pb-l">
        <h3 class="mt-l">Delete key</h3>
        <p>Deleting a key will permanently disable all connections where this key has been used to authenticate the connection</p>
        <button @click="deleteClicked">Delete key</button>
    </div>
</template>

<script>

export default {
    name: 'KeyDeletion',
    props: ['prjnum', 'access_key'],
    emits: ['delete-clicked'],
    methods: {
        deleteClicked() {
            this.emitter.emit('delete-clicked', {prjnum: this.prjnum, access_key: this.access_key, isActive: true}); //Only active keys deleted here. deletion handled in DeletionModal
        }
    }
}
</script>
